<template>
  <footer class="footer">
    <ul class="footer_link">
      <li class="footer_link_item"><a href="/">ロード・オブ・ザ・ウォールについて</a></li>
      <li class="footer_link_item"><a href="https://docs.google.com/forms/d/e/1FAIpQLSfUW4p1DcGSk-HYBS5uA6WZvjk5L5U7KUw0dxSjUlsJn3UDuw/viewform?fbzx=-1185234441729679604" target="_blank">お問い合わせ</a></li>
      <li class="footer_link_item"><Link :href="route('terms')">利用規約</Link></li>
      <li class="footer_link_item"><Link :href="route('privacy')">プライバシーポリシー</Link></li>
      <li class="footer_link_item"><a href="https://caracal.jp/" target="_blank">運営会社</a></li>
    </ul>
    <div class="footer_copyright">
      © ロード・オブ・ザ・ウォール
    </div>
  </footer>
</template>

<script>
  import { Link } from '@inertiajs/inertia-vue3';

  export default {
    components: {
      Link,
    }
  }
</script>